<template>
  <warehouse-component/>
</template>

<script>
import WarehouseComponent from '@/spa/components/board/warehouse/BoardWarehouse';

export default {
  name: 'WarehousePage',
  components: {
    WarehouseComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/store/WarehousePage.vue